import { actionDeclarer } from '../services/actionDeclarer';
import { handleError } from '../services/utils';

export const {
	DISABLE_SIDEBAR,
	SET_API_ERROR_ALERT,
	SET_DOCS,
	SET_INFOBAR,
	SET_INFOBAR_LOADER,
	SET_NAV_LOCK,
	SET_ON_NAV_UNLOCK,
	SET_ON_TAG_MODAL_CLOSE,
	SET_SCREEN_LOADER,
	SET_SHOW_HELP,
	SET_SIDEBAR,
	SET_SIDEBAR_MENU,
	SET_TAG,
	SET_UNLOCK_NAV_CONFIRM
} = actionDeclarer;

const uiReducer = (
	state,
	{
		type,
		payload
	}
) => {
	switch ( type ) {
		case DISABLE_SIDEBAR: {
			return {
				...state,
				sidebar: false,
				sidebarToggle: false
			};
		}

		case SET_API_ERROR_ALERT: {
			const apiErrorAlert = payload
				? handleError( payload )
				: '';

			return {
				...state,
				apiErrorAlert
			};
		}

		case SET_DOCS: {
			return {
				...state,
				docs: payload
			};
		}

		case SET_INFOBAR: {
			return {
				...state,
				infobar: payload
			};
		}

		case SET_INFOBAR_LOADER: {
			return {
				...state,
				infobarLoader: payload
			};
		}

		case SET_NAV_LOCK: {
			return {
				...state,
				navLock: payload
			};
		}

		case SET_ON_NAV_UNLOCK: {
			return {
				...state,
				onNavUnlock: payload
			};
		}

		case SET_ON_TAG_MODAL_CLOSE: {
			return {
				...state,
				onTagModalClose: payload
			};
		}

		case SET_SCREEN_LOADER: {
			return {
				...state,
				screenLoader: payload
			};
		}

		case SET_SHOW_HELP: {
			return {
				...state,
				showHelp: payload
			};
		}

		case SET_SIDEBAR: {
			return {
				...state,
				sidebar: payload,
				sidebarToggle: !payload
			};
		}

		case SET_SIDEBAR_MENU: {
			return {
				...state,
				sidebarMenu: payload,
				sidebar: true,
				sidebarToggle: false
			};
		}

		case SET_TAG: {
			return {
				...state,
				tag: payload
			};
		}

		case SET_UNLOCK_NAV_CONFIRM: {
			return {
				...state,
				unlockNavConfirm: payload
			};
		}

		default:
			return state;
	}
};

export default uiReducer;
